import * as React from "react";
import { CreditCard, CreditCardPayment, StoredCreditCard, PaymentCountry, SiteSettings, Session } from "../types";
import classNames from "classnames";
import CreditCardComp from "../common/CreditCard";
import { StoredCreditCardComp } from "../common/StoredCreditCard";
import { validateStoredCard, scrollWindow } from "../utils";
import t from "../i18n";
import Img from "../Controls/Img";
import NotificationSubscriptionComp from "../common/NotificationSubscription";
import { CatalogService } from "../services/catalog-service";
// import RadioGroup from "../controls/RadioGroup";

declare type PaymentProps = {
  payment: { paymentMethod: "cc" | "pp" | "zz"; creditCardPayment: CreditCardPayment };
  paymentMethodChanged: (paymentMethod: "cc" | "pp") => void;
  creditCardMethodChanged: (creditCardMethod: "new" | "stored") => void;
  creditCardChanged: (creditCard: CreditCard) => void;
  storedCreditCardChanged: (storedCard: StoredCreditCard) => void;
  countries: PaymentCountry[];
  addressSettings: { usUkCa: boolean; others: boolean };
  storedCreditCards: StoredCreditCard[];
  storeCard: boolean;
  productId: number;
  siteSetting: SiteSettings;
  session: Session;
  showNotificationSubscription: boolean;
};
export default class Payment extends React.Component<PaymentProps> {
  _creditCardComp: CreditCardComp | null;
  creditCardMethodChanged = (value: "new" | "stored") => {
    this.props.creditCardMethodChanged(value);
  };
  componentDidMount() {
    scrollWindow(0, 100);
  }
  renderCreditCardType() {
    if (this.props.payment.paymentMethod !== "cc") return null;
    if (this.props.storedCreditCards.length === 0) return null;
    const creditCardMethod = this.props.payment.creditCardPayment.creditCardMethod;
    return (
      <ul id="credit-card-methods" className="nav nav-tabs">
        <li className="nav-item w-50 text-center">
          <a
            className={classNames({ "nav-link": true, active: creditCardMethod === "stored" })}
            href="javascript:void(0)"
            onClick={(e) => this.creditCardMethodChanged("stored")}
          >
            {t.topup("stored_credit_card")}
          </a>
        </li>
        <li className="nav-item w-50 text-center">
          <a
            className={classNames({ "nav-link": true, active: creditCardMethod === "new" })}
            href="javascript:void(0)"
            onClick={(e) => this.creditCardMethodChanged("new")}
          >
            {t.topup("new_card_type")}
          </a>
        </li>
      </ul>
    );
  }
  validate() {
    if (this.props.payment.paymentMethod === "cc") {      
      if (this.props.payment.creditCardPayment.creditCardMethod === "new") {
        if (!this._creditCardComp) return undefined;
        const isValid = this._creditCardComp.validate();
        if (!isValid) return t.error("error_credit_card");
      } else if (this.props.payment.creditCardPayment.creditCardMethod === "stored") {
        const storedCard = this.props.payment.creditCardPayment.storedCard;
        return validateStoredCard(storedCard);
      }
    }
    return undefined;
  }
  renderStoredCreditCard() {
    if (this.props.payment.paymentMethod !== "cc") return null;
    const ccPayment = this.props.payment.creditCardPayment || ({ creditCardMethod: "new" } as CreditCardPayment);
    if (ccPayment.creditCardMethod === "new") return null;
    const storedCard = this.props.payment.creditCardPayment.storedCard || ({} as StoredCreditCard);
    // const selectedCardId = storedCard ? storedCard.creditCardId : undefined;
    const storedCards = this.props.storedCreditCards;
    return (
      <StoredCreditCardComp
        storedCard={storedCard}
        storedCreditCards={storedCards}
        storedCreditCardChanged={this.props.storedCreditCardChanged}
      />
    );
  }
  renderCreditCard() {
    if (this.props.payment.paymentMethod !== "cc") return null;
    const ccPayment = this.props.payment.creditCardPayment || ({ creditCardMethod: "new" } as CreditCardPayment);
    if (ccPayment.creditCardMethod === "stored") return null;
    return (
      <CreditCardComp
        ref={(c) => (this._creditCardComp = c)}
        countries={this.props.countries}
        addressSettings={this.props.addressSettings}
        creditCard={this.props.payment.creditCardPayment.creditCard}
        storedCreditCards={this.props.storedCreditCards}
        creditCardChanged={this.props.creditCardChanged}
        showStoredCard={this.props.storeCard}
      />
    );
  }
  renderProceedWith() {
    if (this.props.payment.paymentMethod === "zz") return null;
    const ccSelectedClass = this.props.payment.paymentMethod === "cc" ? "selected" : "";
    const ppSelectedClass = this.props.payment.paymentMethod === "pp" ? "selected" : "";
    return (
      <div className="row">
        <div className="col-12">
          <h5>{t.autoTopup("proceed_with_for_payment")}</h5>
        </div>
        <div className="col-6">
          <label className={classNames(["form-group eto-card", ccSelectedClass])}>
            <h5>{t.topup("debit_credit_placeholder")}</h5>
            <div>
              <Img src="/images/veon/cc.png" style={{ height: 44 }} />
            </div>
            <div>
              <input
                type="radio"
                name="payment-method"
                value="cc"
                checked={this.props.payment.paymentMethod === "cc"}
                onChange={(e) => this.props.paymentMethodChanged("cc")}
              />
            </div>
          </label>
        </div>
        <div className="col-6">
          <label className={classNames(["form-group eto-card", ppSelectedClass])}>
            <h5>Paypal</h5>
            <div>
              <Img src="/images/veon/paypal.png" style={{ height: 44 }} />
            </div>
            <input
              type="radio"
              name="payment-method"
              value="pp"
              checked={this.props.payment.paymentMethod === "pp"}
              onChange={(e) => this.props.paymentMethodChanged("pp")}
            />
          </label>
        </div>
      </div>
    );
  }
  renderPaypal() {
    if (this.props.payment.paymentMethod === "pp") {
      if (!this.props.siteSetting.isPaypalEnabled) {
        const session = this.props.session;
        return (
          <div className="block" style={{ paddingTop: 10, paddingBottom: 10 }}>
            <div>{t.topup("paypal_conversion_message")}</div>
            <br />
            <div className="font-weight-bold">
              <span>
                {session.netCharge} {session.sourceCurrencyCode}
              </span>
              <i style={{ marginLeft: 15, marginRight: 15 }} className="fa fa-arrow-right" />
              <span>{session.netChargeInUSD} USD</span>
            </div>
            <br />
            <div>{t.topup("paypal_message")}</div>
          </div>
        );
      } else {
        return <div className="block">{t.topup("paypal_message")}</div>;
      }
    }
    return null;
  }
  renderZeroPayment() {
    if (this.props.payment.paymentMethod === "zz") {
      if (CatalogService.isSiteRedemptionPIN()) {
        return <div className="block">{t.topup("store_pin_payment_msg")}</div>;
      } else {
        return <div className="block">{t.topup("zero_amount_payment_message")}</div>;
      }
    }
    return null;
  }
  render() {
    return (
      <React.Fragment>
        {this.renderProceedWith()}
        {this.renderCreditCardType()}
        {this.renderStoredCreditCard()}
        {this.renderCreditCard()}
        {this.renderPaypal()}
        {this.renderZeroPayment()}
        {this.props.showNotificationSubscription && <NotificationSubscriptionComp></NotificationSubscriptionComp>}
        <div className="form-group">
          <span>{t.autoTopup("terms_and_conditions_msg")}&nbsp;</span>
          <a target="_blank" href={`/terms-and-conditions/${this.props.productId}`}>
            {t.autoTopup("terms_and_conditions_link")}
          </a>
          {this.props.siteSetting.showPaymentDisclaimer && (
            <React.Fragment>
              <div style={{ fontWeight: "bold" }}>{t.common("policy")}:</div>
              <div>{t.topup("viva_disclaimer")}</div>
            </React.Fragment>
          )}
        </div>
      </React.Fragment>
    );
  }
}
